
import React from 'react';
import { Belt } from './types';

interface TimelineTrackProps {
  belts: Belt[];
  baseBeltSpacing: number;
  stripeSpacings: number[];
}

export const TimelineTrack: React.FC<TimelineTrackProps> = ({ 
  belts, 
  baseBeltSpacing,
  stripeSpacings 
}) => {
  const startX = 40; // Aligns with the start point for tick marks
  
  // Calculate the total width based on the expanded spacings
  let totalWidth = 0;
  
  // For each belt position
  for (let i = 0; i < belts.length; i++) {
    // Add spacing for all 5 possible positions (belt + 4 stripes)
    const sectionStart = i * 5;
    
    for (let j = 0; j < 5; j++) {
      totalWidth += stripeSpacings[sectionStart + j] || baseBeltSpacing / 5;
    }
  }
  
  // Add spacing for the final segment (after the last belt's last stripe)
  totalWidth += baseBeltSpacing / 5;
  
  const arrowPosition = startX + totalWidth;
  
  return (
    <>
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-0" 
        style={{ 
          left: startX - 40,
          width: arrowPosition - startX + 40,
          height: '16px',
          backgroundColor: '#4b5563'
        }} 
      />
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-10"
        style={{ left: arrowPosition }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            borderTop: '18px solid transparent',
            borderBottom: '18px solid transparent',
            borderLeft: '36px solid #4b5563'
          }}
        />
      </div>
    </>
  );
};
